export const GetToken = (): string | null => {
  return localStorage.getItem("tokenKey");
};
